const WISHLIST_KEY = 'shopify_wishlist_v2';

const getWishlist = () => JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];

const toggleWishlist = (handle, variantId) => {
  const wishlist = getWishlist();
  const itemKey = `${handle}:${variantId}`;
  const index = wishlist.findIndex(item => item === itemKey);

  if (index === -1) {
    wishlist.push(itemKey);
    openWishlistDrawer();
  } else {
    wishlist.splice(index, 1);
  }
  
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
  updateUI();
  
  if (typeof window.renderWishlist === 'function') {
    window.renderWishlist();
  }
  if (typeof window.renderWishlistDrawer === 'function') {
    window.renderWishlistDrawer();
  }
};

const openWishlistDrawer = () => {
  const drawer = document.getElementById('wishlist-drawer');
  if (drawer) {
    drawer.classList.add('active');
    // Disable body scroll
    document.body.style.overflow = 'hidden';
    if (typeof window.renderWishlistDrawer === 'function') window.renderWishlistDrawer();
  }
};

const closeWishlistDrawer = () => {
  const drawer = document.getElementById('wishlist-drawer');
  if (drawer) {
    drawer.classList.remove('active');
    // Re-enable body scroll
    document.body.style.overflow = '';
  }
};

const updateUI = () => {
  const wishlist = getWishlist();
  document.querySelectorAll('[button-wishlist]').forEach(btn => {
    const handle = btn.getAttribute('data-product-handle');
    const variantId = btn.getAttribute('data-variant-id');
    const itemKey = `${handle}:${variantId}`;
    
    // Check for exact match
    let isActive = wishlist.includes(itemKey);
    
    // Fallback: If no variant ID is present yet (loading state), 
    // check if any variant of this handle is in the wishlist
    if (!variantId && handle) {
      isActive = wishlist.some(item => item.startsWith(`${handle}:`));
    }
    
    btn.classList.toggle('active', isActive);
  });

  const counter = document.querySelector('.wishlist-count-bubble');
  if (counter) {
    counter.textContent = wishlist.length;
    counter.parentElement.style.display = wishlist.length > 0 ? 'flex' : 'none';
  }
};

/* =========================================================
   VARIANT CHANGE HANDLER (FOR BOTH PAGE & DRAWER)
========================================================= */

async function handleWishlistVariantChange(input) {
  const card = input.closest('.card-wrapper');
  if (!card) return;

  const productLink = card.querySelector('a[href*="/products/"]');
  if (!productLink) return;

  const handle = productLink.href.split('/products/')[1].split('?')[0];

  try {
    const product = await fetch(`/products/${handle}.js`).then(r => r.json());

    /* ---------- UPDATE SWATCH AVAILABILITY (DISABLE LOGIC) ---------- */
    const colorGroup = card.querySelector('.card__option-group[data-is-color="true"]');
    if (colorGroup) {
      const colorInputs = colorGroup.querySelectorAll('.variant-input');
      const colorIndex = colorGroup.dataset.optionIndex;

      colorInputs.forEach(radio => {
        const val = radio.value;
        const isAvailable = product.variants.some(v => v[colorIndex] === val && v.available);
        radio.classList.toggle('is-unavailable', !isAvailable);
      });
    }

    /* ---------- COLLECT SELECTED OPTIONS ---------- */
    const selectedOptions = {};
    card.querySelectorAll('.card__option-group').forEach(group => {
      const index = group.dataset.optionIndex;
      const checked = group.querySelector('.variant-input:checked');
      if (checked) selectedOptions[index] = checked.value;
    });

    const optionValues = Object.values(selectedOptions);
    if (!optionValues.length) return;

    /* ---------- FIND MATCHING VARIANT ---------- */
    let variant = product.variants.find(v => 
      v.options.join(' / ') === optionValues.join(' / ')
    );

    if (!variant && colorGroup) {
      const colorIdx = colorGroup.dataset.optionIndex;
      variant = product.variants.find(v => v[colorIdx] === selectedOptions[colorIdx]);
    }

    if (!variant) return;

    /* ---------- UPDATE WISHLIST STORAGE (SMART SYNC) ---------- */
    // If ANY variant of this product is in the wishlist, update it to the currently selected one
    const wishlist = getWishlist();
    const existingIndex = wishlist.findIndex(item => item.startsWith(`${handle}:`));

    if (existingIndex !== -1) {
      const newItemKey = `${handle}:${variant.id}`;
      if (wishlist[existingIndex] !== newItemKey) {
        wishlist[existingIndex] = newItemKey;
        localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
        console.log('[Wishlist] Synced wishlist to new variation:', variant.id);
      }
    }

    /* ---------- UPDATE UI ELEMENTS ---------- */
    // Image
    if (variant.featured_image) {
      const img = card.querySelector('.card-main-image');
      if (img) {
        img.classList.add('switching');
        const temp = new Image();
        temp.onload = () => {
          img.src = variant.featured_image.src;
          img.removeAttribute('srcset');
          img.classList.remove('switching');
        };
        temp.src = variant.featured_image.src;
      }
    }

    // Links
    card.querySelectorAll('a[href*="/products/"]').forEach(a => {
      const base = a.href.split('?')[0];
      a.href = `${base}?variant=${variant.id}`;
    });

    // Price
    const priceContainer = card.querySelector('.card-price-container');
    if (priceContainer) {
      const formatMoney = cents => `Rs. ${(cents / 100).toFixed(2)}`;
      const priceBox = priceContainer.querySelector('.price');
      const regular = priceContainer.querySelector('.price-item--regular');
      const sale = priceContainer.querySelector('.price-item--sale');

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (priceBox) priceBox.classList.add('price--on-sale');
        if (sale) sale.textContent = formatMoney(variant.price);
        if (regular) regular.textContent = formatMoney(variant.compare_at_price);
      } else {
        if (priceBox) priceBox.classList.remove('price--on-sale');
        if (regular) regular.textContent = formatMoney(variant.price);
        if (sale) sale.textContent = formatMoney(variant.price);
      }
      priceContainer.innerHTML = priceContainer.innerHTML.replace('From ', '');
    }

    /* ---------- UPDATE ATTRIBUTES ---------- */
    card.dataset.variantId = variant.id;
    const wishlistBtn = card.querySelector('[button-wishlist]');
    if (wishlistBtn) {
      wishlistBtn.setAttribute('data-variant-id', variant.id);
    }
    
    updateUI();

  } catch (err) {
    console.warn('[Wishlist] Variation update failed:', handle, err);
  }
}

/**
 * Initialize availability logic for a specific container
 */
const initCardsAvailability = (container = document) => {
  container.querySelectorAll('.card-wrapper').forEach(card => {
    // Ensure data-variant-id is initialized from the button if missing on wrapper
    if (!card.dataset.variantId) {
      const btn = card.querySelector('[button-wishlist]');
      if (btn) card.dataset.variantId = btn.getAttribute('data-variant-id');
    }

    const checkedInput = card.querySelector('.variant-input:checked');
    if (checkedInput) {
      handleWishlistVariantChange(checkedInput);
    }
  });
};

// Global function for the drawer
window.renderWishlistDrawer = async function() {
  const container = document.getElementById('wishlist-drawer-items');
  const wishlist = getWishlist();
  if (!container) return;

  if (wishlist.length === 0) {
    container.innerHTML = '<p style="text-align:center; padding: 40px 20px; opacity: 0.6;">Your wishlist is empty.</p>';
    updateUI();
    return;
  }

  const productPromises = wishlist.map(item => {
    const [handle, variantId] = item.split(':');
    return fetch(`/products/${handle}?variant=${variantId}&view=card`).then(res => res.ok ? res.text() : '');
  });
  
  const productsHtml = await Promise.all(productPromises);
  container.innerHTML = productsHtml.join('');
  
  initCardsAvailability(container);
  updateUI(); 
};

window.renderWishlist = async function() {
  const grid = document.getElementById('wishlist-grid');
  const emptyMsg = document.getElementById('wishlist-empty');
  const wishlist = getWishlist();

  if (!wishlist.length) {
    if (grid) grid.innerHTML = '';
    if (emptyMsg) emptyMsg.style.display = 'block';
    updateUI();
    return;
  }

  if (emptyMsg) emptyMsg.style.display = 'none';
  if (grid) grid.innerHTML = '<div class="grid__item" style="grid-column:1/-1;text-align:center;padding:4rem">Loading...</div>';

  try {
    const html = await Promise.all(
      wishlist.map(item => {
        const [handle, variantId] = item.split(':');
        return fetch(`/products/${handle}?variant=${variantId}&view=card`)
          .then(r => r.ok ? r.text() : '');
      })
    );

    if (grid) {
      grid.innerHTML = html.join('');
      initCardsAvailability(grid); 
      updateUI();
    }
  } catch (err) {
    console.error('[Wishlist] Render failed:', err);
  }
};

/* =========================================================
   PDP SPECIFIC SYNC & LAYOUT FIX
========================================================= */

const syncVariantId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const currentVariantId = urlParams.get('variant');
  
  if (currentVariantId) {
    const productBtns = document.querySelectorAll('[button-wishlist]');
    const wishlist = getWishlist();

    productBtns.forEach(btn => {
      // Check if button belongs to a product details page
      const isPDP = btn.closest('.product__media-wrapper') || 
                    btn.closest('.product-single') || 
                    btn.closest('.wishlist-product-page-wrapper');
      
      if (isPDP) {
        const handle = btn.getAttribute('data-product-handle');
        const oldVariantId = btn.getAttribute('data-variant-id');
        const newItemKey = `${handle}:${currentVariantId}`;

        // Sync variant ID on the button
        btn.setAttribute('data-variant-id', currentVariantId);
        
        // Smart Sync PDP: If the product (any variant) is wishlisted, update it to this one
        const existingIndex = wishlist.findIndex(item => item.startsWith(`${handle}:`));
        if (existingIndex !== -1) {
          if (wishlist[existingIndex] !== newItemKey) {
            wishlist[existingIndex] = newItemKey;
            localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
            console.log('[Wishlist] PDP Variation synced:', newItemKey);
          }
        }
      }
    });
    updateUI();
  }
};

/**
 * Ensures the PDP Heart Icon moves into the sticky gallery container
 * so it follows the scroll along with the images.
 */
const initStickyHeart = () => {
  const wrapper = document.querySelector('.wishlist-product-page-wrapper');
  const stickyColumn = document.querySelector('.product__column-sticky');
  
  if (wrapper && stickyColumn && !stickyColumn.contains(wrapper)) {
    // Append inside sticky container to follow gallery scroll
    stickyColumn.appendChild(wrapper);
    // Maintain placement via CSS
    wrapper.style.position = 'absolute';
    wrapper.style.top = '20px';
    wrapper.style.right = '20px';
    wrapper.style.zIndex = '10';
  }
};

document.addEventListener('DOMContentLoaded', () => {
  updateUI();
  window.addEventListener('popstate', syncVariantId);
  
  // Listen for all variant changes (Cards + PDP Selectors)
  document.addEventListener('change', (e) => {
    // Handle PDP variant changes (Dawn variant-selects or variant-radios)
    if (e.target.closest('variant-selects') || e.target.closest('variant-radios')) {
      // Small delay to ensure URL has updated
      setTimeout(syncVariantId, 50);
    }
    
    // Handle standard product cards
    if (e.target.classList.contains('variant-input')) {
      handleWishlistVariantChange(e.target);
    }
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[button-wishlist]');
    if (btn) {
      e.preventDefault();
      toggleWishlist(btn.getAttribute('data-product-handle'), btn.getAttribute('data-variant-id'));
    }

    const toggleDrawer = e.target.closest('#wishlist-icon-bubble');
    if (toggleDrawer) {
      e.preventDefault();
      openWishlistDrawer();
    }

    const closeBtn = e.target.closest('.wishlist-drawer__close');
    if (closeBtn || (e.target.id === 'wishlist-drawer' && e.target.classList.contains('wishlist-drawer'))) {
      closeWishlistDrawer();
    }
  });

  // Init PDP specific logic
  syncVariantId();
  initStickyHeart();
  initCardsAvailability(document);
});

// Support for Shopify theme editor and dynamic section loading
document.addEventListener('shopify:section:load', () => {
  syncVariantId();
  initStickyHeart();
  updateUI();
  initCardsAvailability(document);
});